import React, { useState } from "react";
import { Button, DatePicker, Select, TreeSelect } from "antd";
import { PRESET_DATE, RATER_GROUPS } from "./constants";
import moment from "moment";
import "./index.scss";
import GraphLoader from "../../../../../Components/ContentLoaders/GraphLoader";
import { EmptyState } from "../../../../../Packages/EmptyState";
import { toast } from "../../../../../utils/messageUtils";

const FilterComponent = (props) => {
    const allSelected = props.surveyField.length === props.totalCount;
    const getDateValue = () => {
      if (
          props.dateFields.customDateRange &&
          props.dateFields.customDateRange.length > 0
      ) {
          const pickerValue = [
          moment(props.dateFields.customDateRange[0], "YYYY-MM-DD"),
          moment(props.dateFields.customDateRange[1], "YYYY-MM-DD"),
      ];
        return pickerValue;
    }
      return undefined;
  };

    const handleChangeRaterChange = (event) => {
        if (event.length === 0) {
            toast.error("Atleast 1 selection needed")

        }
        else {
            props.handleChangeFilterValues({ raterGroups: event })

        }


    }

    const handleChangeSurveySelection = (value) => {
        if (false) {
            toast.error("Atleast 1 selection needed")
        }
        else {
            props.handleChangeFilterValues({ surveys: value })

        }

    }


    return (
        <>
          {props.loader ? (
              <GraphLoader height={200} width={600} />
          ) : props.isError ? (
              <div className="collapse-container">
                  <EmptyState emptyStateMessage="No data found" />{" "}
              </div>
          ) : (
              <div className="collapse-container">
                  <div className="benchmark-filter">
                      <span className="benchmark-filter__label">Date Range</span>
                      <div className="benchmark-filter__datesection">
                          <Button
                              size="small"
                              type={
                                  props.dateFields.preset === "" &&
                                      props.dateFields.customDateRange.length === 0
                                      ? "primary"
                                      : "default"
                              }
                              onClick={() =>
                                  props.handleChangeFilterValues({
                                      date: { preset: "", customDateRange: [] },
                                  })
                              }
                          >
                                      All time
                                  </Button>
                                  <Button
                                      size="small"
                                      type={
                                          props.dateFields.preset === PRESET_DATE.LAST_12_MONTHS
                                              ? "primary"
                                              : "default"
                                      }
                                      onClick={() =>
                                          props.handleChangeFilterValues({
                                              date: {
                                                  preset: PRESET_DATE.LAST_12_MONTHS,
                                                  customDateRange: [],
                                              },
                                          })
                                      }
                                  >
                                      Last 12 months
                                  </Button>
                                  <Button
                                      size="small"
                                      type={
                                          props.dateFields.preset === PRESET_DATE.LAST_6_MONTHS
                                              ? "primary"
                                              : "default"
                                      }
                                      onClick={() =>
                                          props.handleChangeFilterValues({
                                              date: {
                                                  preset: PRESET_DATE.LAST_6_MONTHS,
                                                  customDateRange: [],
                                              },
                                          })
                                      }
                                  >
                                      Last 6 months
                                  </Button>
                              </div>
                              <div style={{ marginTop: 8 }}>
                                  <div
                                      style={{ color: "#8FA0B6", fontSize: 12, margin: "6px 0 4px" }}
                                  >
                                      Or choose custom range
                                  </div>
                                  <DatePicker.RangePicker
                                      value={getDateValue()}
                                      onChange={props.onCustomRangeChange}
                                      allowClear={true}
                                      className="rangeselector-container"
                                      disabledDate={(current) =>
                                          current && current > moment().endOf("day")
                                      }
                                  />
                              </div>
                          </div>

                          <div className="benchmark-filter">
                              <div className="surveyselection">
                                  <span className="benchmark-filter__label">Survey Name</span>
                                  <span className="light-text">
                                        {props.surveyField.length} of {props.totalCount} selected
                                  </span>
                              </div>
                                <TreeSelect
                                    autoClearSearchValue={false}
                                    // searchValue={searchValue}
                                    // onSearch={handleSearch}
                                    allowClear
                                    treeDefaultExpandAll
                                    treeCheckable
                                  value={props.surveyField}
                                  placeholder="Choose Survey"
                                    treeNodeFilterProp="title"
                                    onChange={(value) =>
                                        handleChangeSurveySelection(value)
                                  }
                                    treeData={props.surveyList}
                                    showSearch
                                  maxTagCount={allSelected ? 0 : 10} // Hide tags when all selected
                                  maxTagPlaceholder={
                                      allSelected
                                          ? () => "All Surveys Selected"
                                          : (omittedValues) => `+${omittedValues.length} more`
                                  }
                                    showArrow
                              />
                          </div>

                          <div className="benchmark-filter">
                              <span className="benchmark-filter__label">Rater Group</span>
                              <Select
                                  showArrow={true}
                                  mode="multiple"
                                  value={props.raterGroups}

                                  onChange={(event) =>
                                      handleChangeRaterChange(event)
                                  }
                                  placeholder="Select rater group(s)"
                                  options={RATER_GROUPS}
                              />
                          </div>

                          <div className="footer-section">
                              {/* <Button className='footer-section__button' onClick={handleReset}>Reset Filters</Button> */}
                              <Button
                                  type="primary"
                                  className="footer-section__button"
                                  onClick={props.handleApply}
                              >
                                  {props.buttonName}
                              </Button>
                          </div>
        </div>
          )}
      </>
  );
};

export default FilterComponent;


